import React from 'react';
import { FaPlay, FaCoins, FaHistory, FaQuestionCircle } from 'react-icons/fa';
import '../styles/labels.css';

interface ActionButtonsProps {
  onPlayClick: () => void;
  onGetTokensClick: () => void;
  onViewAttemptsClick: () => void;
  onHowToPlayClick: () => void;
}

export default function ActionButtons({
  onPlayClick,
  onGetTokensClick,
  onViewAttemptsClick,
  onHowToPlayClick
}: ActionButtonsProps) {
  const handlePlayClick = () => {
    window.open('https://t.me/breakme_ai_bot', '_blank');
    onPlayClick();
  };

  return (
    <div className="action-buttons">
      <div className="play-button-wrapper">
        <span className="beta-pill">BETA</span>
        <button 
          className="nes-btn is-success"
          onClick={handlePlayClick}
        >
          <FaPlay /> PLAY NOW
        </button>
      </div>
      <div className="secondary-buttons">
        <button 
          className="nes-btn"
          onClick={onGetTokensClick}
        >
          <FaCoins /> GET TOKENS
        </button>
        <button 
          className="nes-btn"
          onClick={onHowToPlayClick}
        >
          <FaQuestionCircle /> HOW TO PLAY
        </button>
        <button 
          className="nes-btn"
          onClick={onViewAttemptsClick}
        >
          <FaHistory /> VIEW ATTEMPTS
        </button>
      </div>
    </div>
  );
} 